import React from 'react';
import './App.css';
import {BrowserRouter, Routes, Route} from "react-router-dom"
// importing the components
import Navbar from "./Components/NavBar"
import Login from "./Components/Login"
import Signup from "./Components/Signup"
import Footer from "./Components/Footer"
import Header from './Components/Header';
import ProductInfo from './ProductInfo/ProductInfo';
import SaleProduct from './ProductInfo/SaleProduct';

function App() {
  return (
   <BrowserRouter>
    <Routes>
      <Route path="/" element={
        <div>
          <Navbar />
          <Header />
          <Footer />
        </div>        
        } />
      <Route path="/signup" element={
          <div>
            <Navbar />
            <Signup />  
            <Footer />
          </div>
      } />
      <Route path="/login" element={
          <div>
            <Navbar />
            <Login />
            <Footer />
          </div>
          } />
      <Route path="/productinfo/:id" element={
          <div>
            <Navbar />
            <ProductInfo />
            <Footer />
          </div>
          } />
      <Route path="/saleproduct" element={
          <div>
            <Navbar />
            <SaleProduct />
            <Footer />
          </div>
          } />

    </Routes>
    
   </BrowserRouter>
        
  );
}

export default App;
